const yamlFile = `server: "https://slug.smapply.io"
clientId: yourClientId
clientSecret: yourSecret
refreshToken: yourRefreshToken
accessToken: yourAccessToken`;

module.exports = {
	yamlFile: yamlFile
};
